/* global window URLSearchParams */
import jwtDecode from 'jwt-decode';

let storageWatchers = {};

export const expiredTokenHash = '#tokenExpired';

export default class Token {
	static get() {
		let browserToken;
		if (window.location.search.indexOf('token=') !== -1) {
			/* ignore URL starting with /channel-granted as sometime OAuth uses ?token too */
			if (!window.location.pathname.startsWith('/channel-granted')) {
				const searchParams = new URLSearchParams(window.location.search);
				if (searchParams.has("token")) {
					browserToken = searchParams.get("token");
				}
			}
		}

		let token = window.localStorage.getItem("userToken");
		if (browserToken) {
			if (!token) {
				window.localStorage.setItem("userToken", browserToken);
			}
			return browserToken;
		}

		if (!token && window['config'] && window['config']['token']) {
			token = window['config']['token'];
		}

		if (!token && window['Dativery'] && window['Dativery']['token']) {
			token = window['Dativery']['token'];
		}

		return token;
	}

	static remove() {
		window.localStorage.removeItem('userToken');
		window.localStorage.removeItem('profile');
	}

	static set(token) {
		localStorage.setItem('userToken', token);
	}

	static isExpired() {
		return Token.getExpiration() <= 0;
	}

	static getDecoded() {
		try {
			let token = Token.get();

			if (token) {
				return jwtDecode(token);
			}

			return undefined;
		} catch (e) {
			console.error("Dativery: Error parsing token", e);
		}
	}

	static getExpiration() {
		let expiresIn = 0;
		let decodedToken = Token.getDecoded();

		if (!decodedToken) {
			return 0;
		}

		expiresIn = (decodedToken.exp * 1000) - (new Date().getTime());

		if (expiresIn <= 0) {
			return 0;
		}

		return expiresIn;
	}

	static watcherEvent(event) {
		if (event.key === "userToken") {
			Object.keys(storageWatchers).forEach(callbackKey => {
				try {
					storageWatchers[callbackKey]();
				}
				catch (e) {
					console.error(e);
					Token.stopWatch(storageWatchers[callbackKey]);
				}
			});
		}
	}

	static startWatch(callback) {
		if (!storageWatchers[String(callback)]) {
			storageWatchers[String(callback)] = callback;

			// if this is the first added callback, start the watcher
			if (Object.keys(storageWatchers).length === 1) {
				window.addEventListener('storage', Token.watcherEvent);
			}
		}
	}

	static stopWatch(callback) {
		if (storageWatchers[String(callback)]) {
			delete storageWatchers[String(callback)];
		}

		if (Object.keys(storageWatchers).length === 0) {
			window.removeEventListener('storage', Token.watcherEvent);
		}
	}
}
